export default "__VITE_ASSET__53b4b36e__"